class RecentSearches extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.form = this.querySelector('form');
    this.container = this.querySelector('.recent-searches');
    this.list = this.querySelector('.recent-searches__list');
    
    this.storageKey = 'geneve_recent_searches';
    this.maxItems = 5;
    this.searches = this.getSearches();

    if (!this.input || !this.form || !this.container || !this.list) return;

    this.bindEvents();
    this.render();
    this.restoreFromUrl();
  }

  bindEvents() {
    this.form.addEventListener('submit', this.onSubmit.bind(this));
    
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.input.addEventListener('input', this.onInput.bind(this));
    
    // Close when clicking outside
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.close();
      }
    });

    // Close on escape key
    this.input.addEventListener('keydown', (event) => {
      if (event.code === 'Escape') {
        this.close();
      }
    });
  }

  getSearches() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      console.error('Error reading recent searches from localStorage', e);
      return [];
    }
  }

  saveSearches() {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.searches));
    } catch (e) {
      console.error('Error saving recent searches to localStorage', e);
    }
  }

  addSearch(query) {
    const trimmedQuery = query.trim();
    if (!trimmedQuery) return;

    // Remove if already exists to move it to the top
    this.searches = this.searches.filter(s => s.toLowerCase() !== trimmedQuery.toLowerCase());
    
    // Add to beginning
    this.searches.unshift(trimmedQuery);
    
    // Keep only max items
    if (this.searches.length > this.maxItems) {
      this.searches.pop();
    }
    
    this.saveSearches();
    this.render();
  }

  onSubmit() {
    this.addSearch(this.input.value);
  }

  onFocus() {
    if (this.input.value.trim() === '' && this.searches.length > 0) {
      this.open();
    } else {
      this.close();
    }
  }

  onInput() {
    // If user starts typing, hide recent searches to let predictive search take over
    if (this.input.value.trim() !== '') {
      this.close();
    } else if (this.searches.length > 0) {
      this.open();
    }
  }

  open() {
    this.container.setAttribute('open', '');
    this.container.hidden = false;
  }

  close() {
    this.container.removeAttribute('open');
    this.container.hidden = true;
  }

  onItemClick(query, event) {
    event.preventDefault();
    this.input.value = query;
    this.close();
    this.form.submit();
  }

  render() {
    if (this.searches.length === 0) {
      this.close();
      return;
    }

    this.list.innerHTML = '';
    
    this.searches.forEach(query => {
      const li = document.createElement('li');
      li.className = 'recent-searches__item';
      
      const link = document.createElement('a');
      link.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(query)}`;
      link.className = 'recent-searches__link';
      link.innerHTML = `
        <span class="recent-searches__link-text">${this.escapeHtml(query)}</span>
      `;
      link.addEventListener('click', (e) => this.onItemClick(query, e));

      li.appendChild(link);
      this.list.appendChild(li);
    });
  }

  restoreFromUrl() {
    // If we're on the search page, prepopulate the input from URL if it's empty
    if (window.location.pathname.includes('/search')) {
      const urlParams = new URLSearchParams(window.location.search);
      const q = urlParams.get('q');
      if (q && !this.input.value) {
        this.input.value = q;
        this.addSearch(q); // Also ensure it's saved as recent
      }
    }
  }

  escapeHtml(unsafe) {
    return unsafe
         .replace(/&/g, "&amp;")
         .replace(/</g, "&lt;")
         .replace(/>/g, "&gt;")
         .replace(/"/g, "&quot;")
         .replace(/'/g, "&#039;");
  }
}

if (!window.customElements.get('recent-searches')) {
  window.customElements.define('recent-searches', RecentSearches);
}
